import { Component, OnInit, signal } from '@angular/core';
import { CountryService } from '@app/services/country.service';

import { Parameters } from '@app/components/parameters/parameters';
import { ParametersService } from '@app/components/parameters/parameters.service';

import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from '@app/services';
import { Country, Locale } from '@app/models/locales';


@Component({
    selector: 'app-country-selection',
    templateUrl: './country-selection.component.html',
    styleUrls: ['./country-selection.component.css'],
    standalone: false
})
export class CountrySelectionComponent implements OnInit {
    viewMode = signal<'kiosk' | ''>('');
    params: Parameters;

    isLoading: boolean;

    countries: Country[] = [];

    countryMap: Map<string, Country[]> = new Map<string, Country[]>([
        ['EUROPE', []],
        ['AMERICA', []],
        ['OCEANIA', []],
        ['ASIA', []],
        ['AFRICA', []],
        ['SOUTH AMERICA', []],
        ['GLOBAL', []]
    ]);

    clickedCountry: Country;
    private nextRoute = '/home';

    constructor(
        private readonly countryService: CountryService,
        private readonly parametersService: ParametersService,
        private readonly router: Router,
        private readonly translateService: TranslationService,
        private readonly route: ActivatedRoute
    ) {
        route.queryParamMap.subscribe(params => {
            const viewMode = params.get('viewMode');
            this.viewMode.set(viewMode === 'kiosk' ? 'kiosk' : '');
        });
    }

    ngOnInit() {
        this.isLoading = true;

        this.parametersService
            .getParametersObservable()
            .subscribe(parameters =>
                this.params = parameters);
        this.nextRoute = decodeURIComponent(this.route.snapshot.queryParams['returnUrl']) ?? '/home';
        this.countryService.getLocales().subscribe({
            next: continents => {
                continents.forEach(continent => {
                    continent.countries.sort((a, b) => a.name.localeCompare(b.name));
                    this.countryMap.set(continent.name, continent.countries);
                    this.countries.push(...continent.countries);
                });
                this.isLoading = false;
            },
            error: () => this.isLoading = false
        });
    }

    countryOnClick(country: Country): void {
        this.clickedCountry = country;

        if (country.locales.length === 1) {
            this.languageOnClick(country.locales[0]);
        }
    }

    languageOnClick(locale: Locale): void {
        this.parametersService.setCountry(locale);
        const lang = locale.code.split('_')[0];
        this.parametersService.setLanguage(lang);
        this.translateService.changeLanguage(lang);
        const nextRoute = decodeURIComponent(decodeURIComponent(this.nextRoute));
        if (this.viewMode() === 'kiosk' && !nextRoute.includes('viewMode=kiosk')) {
            if (nextRoute.includes('?')) {
                this.router.navigateByUrl(nextRoute + '&viewMode=kiosk');
            } else {
                this.router.navigateByUrl(nextRoute + '?viewMode=kiosk');
            }
            return;
        }
        this.router.navigateByUrl(nextRoute);
    }
}
